import { AnbLoaderConfig, HorizontalPosition, SnackBarOptions, VerticalPosition } from '@anb/ng-ui';
import { ROUTE } from '@core/models/route';
import { nl } from 'date-fns/locale';

/** Application contants. */
export const AppConstants = {
  locale: 'nl-BE',
  defaultLanguage: 'nl',
  datefnsLocale: { locale: nl },
  defaultDateFormat: 'dd/MM/yyyy',
  defaultCurrency: 'EUR',

  haToMeters: 10000,

  loaderConfig: {
    exclude: ['https://loc.geopunt.be/v4/suggestion?q='],
    excludeRegexp: ['http.+.informatievlaanderen.be.+'],
  } as AnbLoaderConfig,

  // Http interceptor settings.
  interceptorKeys: {
    skipHeader: 'X-Skip-Interceptor',
  },

  // General Attachemnets
  attachments: {
    maxAllowedAttachments: 10,
    maxSizeMb: 10,
    allowedExtensions: ['pdf', 'zip', 'doc', 'docx', 'xls', 'xlsx', 'txt'],
    allowedExcelExtensions: ['xls', 'xlsx', 'xlsm'],
  },

  // Codes cache
  cacheDurationSeconds: 300,

  // maps
  maps: {
    grbLayerId: 'grb grey',
    orthoLayerId: 'grb omwrgbmrvl',
  },

  defaultPath: ROUTE.OVERZICHT,

  defaultSnackBarOptions: {
    durationInSeconds: 2,
    horizontalPosition: HorizontalPosition.Right,
    verticalPosition: VerticalPosition.Top,
  } as SnackBarOptions,
};
